import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import styles from "./BookingSingle.module.css";

const STATUS_OPTIONS = [
  { value: "requested", label: "Requested" },
  { value: "confirmed", label: "Confirmed" },
  { value: "in_progress", label: "In progress" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

const ICON_BACK = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12H5M11 18l-6-6 6-6" />
  </svg>
);
const ICON_CHEVRON = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9l6 6 6-6" />
  </svg>
);
const ICON_CHECK = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 6L9 17l-5-5" />
  </svg>
);
const ICON_COPY = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
  </svg>
);
const ICON_WALLET = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 12V7H5a2 2 0 010-4h14v4" /><path d="M3 5v14a2 2 0 002 2h16v-5" /><path d="M18 12a2 2 0 000 4h4v-4z" />
  </svg>
);
const ICON_CALENDAR = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
  </svg>
);
const ICON_USERS = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
  </svg>
);
const ICON_TRIP = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
  </svg>
);
const ICON_MAP_PIN = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0116 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);
const ICON_PHONE = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);
const ICON_USER = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" />
  </svg>
);
const ICON_BUILDING = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="2" width="16" height="20" rx="1" />
    <path d="M9 22v-4h6v4M9 6h.01M15 6h.01M9 10h.01M15 10h.01M9 14h.01M15 14h.01" />
  </svg>
);
const ICON_ALERT = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);
const ICON_X = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);
const ICON_CAR = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 17H3a2 2 0 01-2-2V9a2 2 0 012-2h14a2 2 0 012 2v1" />
    <path d="M14 17H9m-4 0a2 2 0 100 4 2 2 0 000-4zm11 0a2 2 0 100 4 2 2 0 000-4z" />
    <path d="M5 9l2-5h10l2 5" />
    <path d="M15 9v8" />
  </svg>
);
const ICON_ARROW_RIGHT = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

function statusLabel(value) {
  return STATUS_OPTIONS.find((s) => s.value === value)?.label ?? value;
}

function formatDate(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString("en-IN", {
    day: "numeric", month: "short", year: "numeric",
  });
}

function formatDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", {
    day: "numeric", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export default function BookingSingle() {
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusUpdating, setUpdating] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [copiedKey, setCopiedKey] = useState(null);
  const [pendingStatus, setPending] = useState(null);
  const [toast, setToast] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();
  const statusWrapRef = useRef(null);
  const toastTimerRef = useRef(null);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/bulkbooking/singleDetails`,
          { params: { id }, withCredentials: true }
        );
        if (response.data.length > 0) setBooking(response.data[0]);
      } catch (err) {
        setError("Could not load booking details.");
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [id]);

  useEffect(() => {
    const handler = (e) => {
      if (statusWrapRef.current && !statusWrapRef.current.contains(e.target))
        setPickerOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => () => { if (toastTimerRef.current) clearTimeout(toastTimerRef.current); }, []);

  const showToast = (type, message) => {
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    setToast({ type, message });
    toastTimerRef.current = setTimeout(() => setToast(null), 3000);
  };

  const requestStatusChange = (newStatus) => {
    setPickerOpen(false);
    if (!booking || newStatus === booking.status) return;
    setPending(newStatus);
  };

  const confirmStatusChange = async () => {
    if (!booking || !pendingStatus) return;
    const newStatus = pendingStatus;
    setUpdating(true);
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/bulkbooking/changestatus`,
        null,
        { params: { id: booking.request_id, newStatus }, withCredentials: true }
      );
      setBooking((prev) => ({ ...prev, status: newStatus }));
      showToast("success", response.data?.message || "Update Done");
    } catch (err) {
      showToast("error", err.response?.data?.message || err.response?.data?.error || "Server error");
    } finally {
      setUpdating(false);
      setPending(null);
    }
  };

  const handleCopy = (key, value) => {
    navigator.clipboard?.writeText(value);
    setCopiedKey(key);
    setTimeout(() => setCopiedKey((k) => (k === key ? null : k)), 1500);
  };

  if (loading) {
    return (
      <div className={styles.state}>
        <span className={styles.spinner} /> Loading booking details…
      </div>
    );
  }

  if (error || !booking) {
    return (
      <div className={`${styles.state} ${styles.stateError}`}>
        {error ?? "Booking not found."}
      </div>
    );
  }

  // ── derived values ──────────────────────────────────────────────────────────
  const departureDate = formatDate(booking.departure_date);
  const requestedAt = formatDateTime(booking.request_date_time);
  const durationLabel = booking.duration_in_day
    ? `${booking.duration_in_day} day${booking.duration_in_day > 1 ? "s" : ""}`
    : null;

  // total vehicle count across all routes
  const totalVehicles = (booking.routes ?? []).reduce((sum, route) =>
    sum + (route.vehicles ?? []).reduce((s, v) => s + (v.quantity || 0), 0), 0
  );

  const tripFields = [
    { label: "Departure", value: departureDate },
    { label: "Duration", value: durationLabel },
    { label: "Category", value: booking.category || null },
    { label: "Trip detail", value: booking.trip_detail || null },
    { label: "Price", value: booking.price ? `₹${booking.price}` : null },
    { label: "GST", value: booking.gst || null },
  ];

  const contactFields = [
    { label: "Primary", value: booking.contact, href: booking.contact ? `tel:${booking.contact}` : null },
    { label: "Alternate", value: booking.alt_contact, href: booking.alt_contact ? `tel:${booking.alt_contact}` : null },
  ];

  const coordinatorFields = [
    { label: "Name", value: booking.coordinator || null },
    { label: "Contact", value: booking.coordinator_contact || null, href: booking.coordinator_contact ? `tel:${booking.coordinator_contact}` : null },
  ];

  const businessFields = [
    { label: "Name", value: booking.business || null },
    { label: "User ID", value: booking.user_id ? booking.user_id.slice(0, 12) + "…" : null, mono: true },
    { label: "GST", value: booking.gst || null },
  ];

  const idChips = [
    { key: "request_id", label: "Request ID", value: booking.request_id },
    { key: "order_id", label: "Order ID", value: booking.order_id },
  ].filter((c) => c.value);

  const currentCfg = STATUS_OPTIONS.find((s) => s.value === booking.status) ?? STATUS_OPTIONS[0];

  return (
    <div className={styles.page}>

      {/* ── Header ── */}
      <div className={styles.header}>
        <button className={styles.backBtn} onClick={() => navigate(-1)}>
          {ICON_BACK} Back
        </button>

        <div className={styles.titleBlock}>
          <div className={styles.titleRow}>
            <h1 className={styles.title}>Booking #{booking.id}</h1>

            {booking.category && (
              <span className={styles.categoryBadge}>{booking.category}</span>
            )}

            <div className={styles.statusWrap} ref={statusWrapRef}>
              <button
                className={`${styles.statusBadge} ${styles[currentCfg.value]} ${pickerOpen ? styles.statusBadgeOpen : ""}`}
                onClick={() => setPickerOpen((v) => !v)}
                disabled={statusUpdating}
                aria-haspopup="true"
                aria-expanded={pickerOpen}
              >
                {statusUpdating
                  ? <span className={styles.statusSpinner} />
                  : <span className={styles.statusDot} />}
                {currentCfg.label}
                {ICON_CHEVRON}
              </button>

              {pickerOpen && (
                <div className={styles.statusPicker} role="menu">
                  {STATUS_OPTIONS.map((opt) => (
                    <button
                      key={opt.value}
                      className={`${styles.statusOpt} ${opt.value === booking.status ? styles.statusOptActive : ""}`}
                      onClick={() => requestStatusChange(opt.value)}
                      role="menuitem"
                    >
                      <span className={`${styles.statusOptDot} ${styles[opt.value]}`} />
                      {opt.label}
                      {opt.value === booking.status && (
                        <span className={styles.statusOptCheck}>{ICON_CHECK}</span>
                      )}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          <p className={styles.subline}>
            {booking.business || "No business"} &nbsp;·&nbsp; Requested {requestedAt}
          </p>
        </div>
      </div>

      {/* ── Metric strip ── */}
      <div className={styles.metricsRow}>
        <div className={styles.metricCard}>
          <div className={styles.metricIcon}>{ICON_WALLET}</div>
          <div>
            <div className={styles.metricLabel}>Booking fee</div>
            <div className={styles.metricValue}>
              {booking.booking_fees ? `₹${parseFloat(booking.booking_fees).toLocaleString("en-IN")}` : "—"}
            </div>
            <div className={styles.metricSub}>excl. GST</div>
          </div>
        </div>

        <div className={styles.metricCard}>
          <div className={styles.metricIcon}>{ICON_CALENDAR}</div>
          <div>
            <div className={styles.metricLabel}>Duration</div>
            <div className={styles.metricValue}>{durationLabel ?? "—"}</div>
            {departureDate && <div className={styles.metricSub}>departs {departureDate}</div>}
          </div>
        </div>

        <div className={styles.metricCard}>
          <div className={styles.metricIcon}>{ICON_CAR}</div>
          <div>
            <div className={styles.metricLabel}>Vehicles</div>
            <div className={styles.metricValue}>{totalVehicles || "—"}</div>
            <div className={styles.metricSub}>
              {totalVehicles ? `across ${booking.routes?.length ?? 0} route${(booking.routes?.length ?? 0) !== 1 ? "s" : ""}` : "not specified"}
            </div>
          </div>
        </div>
      </div>

      {/* ── Content grid ── */}
      <div className={styles.contentGrid}>

        {/* Left column */}
        <div className={styles.column}>
          <div className={styles.card}>
            <div className={styles.cardTitleRow}>
              {ICON_TRIP}
              <span className={styles.cardTitle}>Trip details</span>
            </div>
            {tripFields.map((f) => (
              <div className={styles.fieldRow} key={f.label}>
                <span className={styles.fieldLabel}>{f.label}</span>
                <span className={`${styles.fieldValue} ${!f.value ? styles.fieldValueMuted : ""}`}>
                  {f.value ?? "—"}
                </span>
              </div>
            ))}

            {booking.notes && (
              <>
                <div className={`${styles.cardTitleRow} ${styles.cardTitleSpaced}`}>
                  <span className={styles.cardTitle}>Notes</span>
                </div>
                <div className={styles.notesBox}>{booking.notes}</div>
              </>
            )}
          </div>

          {/* Routes */}
          {booking.routes?.length > 0 && (
            <div className={styles.card}>
              <div className={styles.cardTitleRow}>
                {ICON_MAP_PIN}
                <span className={styles.cardTitle}>Routes</span>
                <span className={styles.cardCount}>{booking.routes.length}</span>
              </div>

              <div className={styles.routesList}>
                {booking.routes.map((route, i) => (
                  <div className={styles.routeItem} key={i}>
                    <div className={styles.routeIdxCol}>
                      <div className={styles.routeIdx}>{i + 1}</div>
                      {i < booking.routes.length - 1 && <div className={styles.routeLine} />}
                    </div>

                    <div className={styles.routeBody}>
                      {/* pickup → drop_off */}
                      <div className={styles.routeLocRow}>
                        <div className={styles.routeLoc}>
                          <span className={styles.routeLocDot} style={{ background: "var(--success)" }} />
                          <span className={styles.routeLocText}>{route.pickup || "—"}</span>
                        </div>
                        <span className={styles.routeArrow}>{ICON_ARROW_RIGHT}</span>
                        <div className={styles.routeLoc}>
                          <span className={styles.routeLocDot} style={{ background: "var(--danger)" }} />
                          <span className={styles.routeLocText}>{route.drop_off || "—"}</span>
                        </div>
                      </div>

                      {/* pickup date / time if provided */}
                      {(route.pickup_date || route.pickup_time) && (
                        <div className={styles.routeMeta}>
                          {[route.pickup_date, route.pickup_time].filter(Boolean).join("  ·  ")}
                        </div>
                      )}

                      {/* vehicles */}
                      {route.vehicles?.length > 0 && (
                        <div className={styles.vehicleList}>
                          {route.vehicles.map((v, vi) => (
                            <span className={styles.vehicleChip} key={vi}>
                              {ICON_CAR}
                              {v.quantity}× {v.vehicle_name}
                            </span>
                          ))}
                        </div>
                      )}

                      {/* route notes */}
                      {route.notes && (
                        <div className={styles.routeNotes}>{route.notes}</div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Right column */}
        <div className={styles.column}>
          <div className={styles.card}>
            <div className={styles.cardTitleRow}>
              {ICON_PHONE}
              <span className={styles.cardTitle}>Contacts</span>
            </div>
            {contactFields.map((f) => (
              <div className={styles.fieldRow} key={f.label}>
                <span className={styles.fieldLabel}>{f.label}</span>
                {f.href
                  ? <a href={f.href} className={`${styles.fieldValue} ${styles.fieldValueAccent}`}>{f.value}</a>
                  : <span className={`${styles.fieldValue} ${styles.fieldValueMuted}`}>—</span>}
              </div>
            ))}
          </div>

          <div className={styles.card}>
            <div className={styles.cardTitleRow}>
              {ICON_USER}
              <span className={styles.cardTitle}>Coordinator</span>
            </div>
            {coordinatorFields.map((f) => (
              <div className={styles.fieldRow} key={f.label}>
                <span className={styles.fieldLabel}>{f.label}</span>
                {f.href
                  ? <a href={f.href} className={`${styles.fieldValue} ${styles.fieldValueAccent}`}>{f.value}</a>
                  : <span className={`${styles.fieldValue} ${!f.value ? styles.fieldValueMuted : ""}`}>{f.value ?? "—"}</span>}
              </div>
            ))}
          </div>

          <div className={styles.card}>
            <div className={styles.cardTitleRow}>
              {ICON_BUILDING}
              <span className={styles.cardTitle}>Business</span>
            </div>
            {businessFields.map((f) => (
              <div className={styles.fieldRow} key={f.label}>
                <span className={styles.fieldLabel}>{f.label}</span>
                <span className={`${styles.fieldValue} ${!f.value ? styles.fieldValueMuted : ""} ${f.mono ? styles.fieldValueMono : ""}`}>
                  {f.value ?? "—"}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── ID chips ── */}
      {idChips.length > 0 && (
        <div className={styles.idsRow}>
          {idChips.map((c) => (
            <div className={styles.idChip} key={c.key}>
              <div>
                <span className={styles.idChipLabel}>{c.label}</span>
                <span className={styles.idChipText}>{c.value}</span>
              </div>
              <button className={styles.copyBtn} onClick={() => handleCopy(c.key, c.value)} aria-label={`Copy ${c.label}`}>
                {copiedKey === c.key ? ICON_CHECK : ICON_COPY}
              </button>
            </div>
          ))}
        </div>
      )}

      {/* ── Confirm modal ── */}
      {pendingStatus && (
        <div className={styles.modalOverlay} onClick={() => !statusUpdating && setPending(null)}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
            <div className={styles.modalIcon}>{ICON_ALERT}</div>
            <h3 className={styles.modalTitle}>Change booking status?</h3>
            <p className={styles.modalBody}>
              Are you sure you want to change the status from{" "}
              <span className={`${styles.modalStatusPill} ${styles[booking.status]}`}>
                {statusLabel(booking.status)}
              </span>{" "}
              to{" "}
              <span className={`${styles.modalStatusPill} ${styles[pendingStatus]}`}>
                {statusLabel(pendingStatus)}
              </span>?
            </p>
            <div className={styles.modalActions}>
              <button className={styles.modalCancelBtn} onClick={() => setPending(null)} disabled={statusUpdating}>
                Cancel
              </button>
              <button className={styles.modalConfirmBtn} onClick={confirmStatusChange} disabled={statusUpdating}>
                {statusUpdating ? "Updating…" : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Toast ── */}
      {toast && (
        <div className={`${styles.toast} ${styles[`toast_${toast.type}`]}`} role="status">
          {toast.type === "success" ? ICON_CHECK : ICON_ALERT}
          <span>{toast.message}</span>
          <button className={styles.toastClose} onClick={() => setToast(null)} aria-label="Dismiss">
            {ICON_X}
          </button>
        </div>
      )}
    </div>
  );
}